import { TEnvConfig } from './env.interfact'
import { PROD_CONFIG } from './prod'
import { DEV_CONFIG } from './dev'
import { LOCAL_CONFIG } from './local'
import { BETA_CONFIG } from './beta'
import { SUPPORTED_LANGUAGES } from '@/i18n/languages/types'
import { Address } from 'viem'

export const ENV = (process.env.REACT_APP_ENV ??
  process.env.NODE_ENV ??
  'production') as 'production' | 'beta' | 'development' | 'local'

export const CONFIGS: { [env: string]: TEnvConfig } = {
  production: PROD_CONFIG,
  development: DEV_CONFIG,
  local: LOCAL_CONFIG,
  beta: BETA_CONFIG
}

export const ENV_CONFIG = CONFIGS[ENV] ?? PROD_CONFIG
export const FRONTEND_URL = ENV_CONFIG.kulapPlusFrontendUrl
export const LOCAL_STORAGE_PREFIX = 'KULAP_PLUS'
export const APP_NAME = 'KULAP_PLUS'
export const APP_VERSION = '1.0.0'

export const TEN_YEARS_SECS = 60 * 60 * 24 * 365 * 10
export const NATIVE_TOKEN_ADDRESS = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE'
export const PRICE_SLIPPAGE_PERCENTAGE = 1
export const CLOUDFLARE_TURNSTILE_SITE_KEY = process.env
  .REACT_APP_CLOUDFLARE_TURNSTILE_SITE_KEY as string

export const APP_HEADER_HEIGHT = 100

export const KULAP_FACEBOOK_CONTRACT_URL = 'https://www.facebook.com/KULAP.io'

export const THAID_SCOPE =
  'pid birthdate address given_name middle_name family_name given_name_en middle_name_en family_name_en title title_en gender ial date_of_issuance date_of_expiry'

export const getDepositSwapContractAddress = (
  chainId: number
): Address | undefined => {
  return ENV_CONFIG.depositSwapContractAddresses[chainId]
}
